import { PaymentMethodWithCashlessAndBonusLabelTranslationKeys } from "#i18n/translations/pt-BR/components/payment-method-with-cashless-and-bonus";

export const PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_ES_MX: PaymentMethodWithCashlessAndBonusLabelTranslationKeys = {
	ZigPosCredit: "ZigPos Crédito",
	ZigPosCreditInInstallments: "ZigPos Crédito en Cuotas",
	ZigPosDebit: "ZigPos Débito",
	CreditCard: "Tarjeta de crédito",
	DebitCard: "Tarjeta de débito",
	Cash: "Efectivo",
	App: "App",
	Voucher: "Voucher",
	Anticipated: "Antecipado",
	Pix: "Pix",
	Cashless: "Cashless",
	IntegratedFoodVoucher: "Vale de alimentación",
	MBWay: "MBWay",
	Bonus: "Bonus",
	MinimumConsumption: "Consumación mínima",
	Ifood: "Ifood",
	DigitalCashless: "Cashless Digital",
	Online: "Online",
	DeliveryOnline: "Delivery Online",
};
